import React from 'react'
import cx from 'classnames'
import { DATE_FORMAT } from '~constants'
import styles from '../Calendar.module.scss'
import { Heading } from '~elements'
import NextButton from '../views/MonthView/NextButton/NextButton'
import PrevButton from '../views/MonthView/PrevButton/PrevButton'
import { Dayjs } from 'dayjs'
import dayjs from 'utils/dayjs'
import { isNextButtonDisabled, isPrevButtonDisabled } from '../utils'
import { DATE_MONTH_YEAR } from '../constants'

interface CalendarBottomNavigationProps {
  hideNavTitle?: boolean
  month?: Dayjs
  position?: string | 'top' | 'bottom'
  toggleView?: React.ReactNode
  handleNavigation: (key: string) => void
  activeMonthList: string[]
}

const CalendarBottomNavigation = ({
  hideNavTitle,
  month,
  position = 'bottom',
  toggleView,
  handleNavigation,
  activeMonthList
}: CalendarBottomNavigationProps) => {
  const currentMonth = month ? month.format(`${DATE_MONTH_YEAR}`) : dayjs().format(`${DATE_MONTH_YEAR}`)

  const isPrevDisabled = isPrevButtonDisabled(
    month ? month.format(`${DATE_FORMAT.SHORT_MONTH}-${DATE_FORMAT.SHORT_YEAR}`) : '',
    activeMonthList
  )
  const isNextDisabled = isNextButtonDisabled(
    month ? month.format(`${DATE_FORMAT.SHORT_MONTH}-${DATE_FORMAT.SHORT_YEAR}`) : '',
    activeMonthList
  )

  const prevMonthName = dayjs(currentMonth, `${DATE_MONTH_YEAR}`).subtract(1, 'month').format(DATE_FORMAT.MONTH)
  const nextMonthName = dayjs(currentMonth, `${DATE_MONTH_YEAR}`).add(1, 'month').format(DATE_FORMAT.MONTH)

  const navigateTo = (e: React.MouseEvent<HTMLElement>, key: string, element: string = '') => {
    if (element == 'child' && e) {
      e.stopPropagation()
    }
    window.scrollTo({ top: 0, behavior: 'smooth' })
    handleNavigation(key)
  }

  return (
    <div className={cx([styles['calendar__month-navs'], styles[`calendar__month-navs--${position}`]])}>
      {!hideNavTitle && month && (
        <div className={styles['calendar__current-month-year-title']} id='calendarMonthTitle'>
          <h2>{month.format(`${DATE_FORMAT.MONTH_FULL_NAME} ${DATE_FORMAT.YEAR}`)}</h2>
        </div>
      )}
      <div
        className={cx([
          styles['calendar__month-nav'],
          styles['calendar__month-nav--prev'],
          `${isPrevDisabled && styles['calendar__month-nav--is-disabled']}`
        ])}
        onClick={isPrevDisabled ? undefined : e => navigateTo(e, 'previous')}
      >
        <PrevButton
          disabled={isPrevDisabled!}
          clickCallback={(e: React.MouseEvent<HTMLElement, MouseEvent>) => navigateTo(e, 'previous', 'child')}
        />
        {hideNavTitle && <Heading level={2}>{prevMonthName}</Heading>}
      </div>
      <div
        className={cx([
          styles['calendar__month-nav'],
          styles['calendar__month-nav--next'],
          `${isNextDisabled && styles['calendar__month-nav--is-disabled']}`
        ])}
        onClick={isNextDisabled ? undefined : e => navigateTo(e, 'next')}
      >
        {hideNavTitle && <Heading level={2}>{nextMonthName}</Heading>}
        <NextButton
          disabled={isNextDisabled}
          clickCallback={(e: React.MouseEvent<HTMLElement, MouseEvent>) => navigateTo(e, 'next', 'child')}
        />
      </div>
    </div>
  )
}

export default CalendarBottomNavigation
